import { Injectable } from "@angular/core";
import { Entity, TaskInstance } from "@common/types";
import { updateEntity } from "src/app/entity-changes/update-entity";
import { JobPharmaDataAccessService, JobPharmaDetailService, UpdateDueDateRequest } from "../../services";
import { DataManagerService } from "@services/data-manager.service";


@Injectable()
export class JobPharmaTasksScheduleTableService {
    readonly LOG_TAG = 'job-pharma-tasks-schedule-table-service';

    constructor(
        private jobPharmaDataAccessService: JobPharmaDataAccessService, 
        private jobPharmaDetailService: JobPharmaDetailService,
        private dataManager: DataManagerService
    ) {}

    async updateDateDue({task, date}: UpdateDueDateRequest) {
        const reset = updateEntity(task as Entity<TaskInstance>, 'DateDue', date);
        await this.dataManager.saveEntity('TaskInstance');
        try {
            const { AffectedGroupTaskInstanceKeys } = await this.jobPharmaDataAccessService.updateTaskDateDues([{task, date}]);
            await this.jobPharmaDataAccessService.getTaskInstancesByKeys(AffectedGroupTaskInstanceKeys);
        } catch (err) {
            reset();
            throw err;
        }
    }

    async bulkUpdateDateDue(updates: UpdateDueDateRequest[]) {
        await this.dataManager.saveEntity('TaskInstance');
        try {
            const { AffectedGroupTaskInstanceKeys } = await this.jobPharmaDataAccessService.updateTaskDateDues(updates);
            await this.jobPharmaDataAccessService.getTaskInstancesByKeys(AffectedGroupTaskInstanceKeys);
        } catch (err) {
            throw err;
        }
    }
}